import { render, staticRenderFns } from "./RequesterList.vue?vue&type=template&id=d990a418"
import script from "./RequesterList.vue?vue&type=script&lang=js"
export * from "./RequesterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports